import type { BannerNotificationType } from "@/store/bannerNotificationStore";
import { useBannerNotificationStore } from "@/store/bannerNotificationStore";

import { BannerNotificationGroup } from "./BannerNotificationGroup";

const SEVERITY_ORDER: BannerNotificationType[] = ["error", "warning", "info", "success"];

export const BannerNotificationBar = () => {
  const notifications = useBannerNotificationStore((s) => s.notifications);
  const dismiss = useBannerNotificationStore((s) => s.dismiss);

  if (notifications.length === 0) return null;

  const groups = SEVERITY_ORDER.map((type) => ({
    type,
    items: notifications.filter((n) => n.type === type),
  })).filter((g) => g.items.length > 0);

  return (
    <>
      {groups.map((g) => (
        <BannerNotificationGroup key={g.type} type={g.type} items={g.items} dismiss={dismiss} />
      ))}
    </>
  );
};
